import type { ABTestListServiceConfig, GetABTestByIdServiceConfig } from '@/services/httpServices/ABTestServices/types';

import { createQueryKey } from './queryKeyUtils';

export function abTestListKeys(config?: ABTestListServiceConfig) {
  return createQueryKey(['abTestList'], config);
}

/**
 * Creates a unique query key for infinite AB test list queries
 * Includes 'infinite' prefix to differentiate from regular list queries
 */
export function infiniteAbTestListKeys(config?: ABTestListServiceConfig) {
  return ['infinite', ...abTestListKeys(config)];
}

export function abTestByIdKey(config?: GetABTestByIdServiceConfig) {
  return createQueryKey(['abTestById'], config);
}
